<textarea class="form-control" [(ngModel)]="textoRespuesta" (ngModelChange)="onChangeTextoRespuesta()"></textarea>
